import React, {useState} from 'react'
import {  Form, Header, Input, Radio,Message, Button } from 'semantic-ui-react'

import DatePicker from "react-datepicker";
 
import "react-datepicker/dist/react-datepicker.css";

import es from 'date-fns/locale/es';

// import { useAlert } from "react-alert";

export   function Step1a(props) {

   const [state, setState] = useState({value:"", title: "", name:"", mrn:"", gender:"",})

   const [date, setDate] = useState({ age:""})
   const [dt, setDt] = useState({dob: ""})

   const [gndr, setGndr] = useState({gender: ''})

   const [title, setTitle] = useState()





   let dateInput = React.createRef();
    if (props.currentStep !== 1) {
        return null
    } 
    // const state = {}
 


    const calculate_age = (dob1) => {
        var today = new Date();
        var birthDate = new Date(dob1);  // create a date object directly from `dob1` argument
        if(dob1 == null){
            return
        }

        // console.log(dob1)

        var age_now = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        // if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) 
        // {
        //     age_now--;
        // }

        if (age_now.toString().length < 4 && age_now > -1 ){
            // console.log(age_now);
            // setState({ age_now })
            setDate({ age: age_now })

            const event = {target:{name:'age', value:age_now}}
            props.handleChange(event)
        }
        
        
       
        return age_now;
      }


    // const handleAge = () => {
    //     // e.preventDefault();
    //     console.log(date.age)
    //     const event = {target:{name:'age', value:date.age}}
    //     props.handleChange(event)
            
    // }

 


 
    const handleDob = (date)=>{
        calculate_age(date)
        setDt({dob:date})
        const event = {target:{name:'dob', value:date}}
        props.handleChange(event)
        // handleAge()
    }


    const handleGender = (e, { value })=>{
      setState({ value })
      const event = {target:{name:'gender', value:value}}
      props.handleChange(event)

  }


    const clearDob=(e)=>{
        e.preventDefault();
        setDate({ age: "" })
        setDt({dob:''})
    }


    const handleTitle = ()=>{
      let mrn = ''
      if (props.mrn) {
        mrn = 'MRN#' + ' ' +  (props.mrn) 
      }
      let titleMrn =   (date.age)+' ' + (props.gender)  + ' ' + (props.name) +' '+ (mrn) 
      setTitle(titleMrn)

      const event = {target:{name:'title', value:titleMrn}}
      props.handleChange(event)

  }
    

    const ShowTitle=()=>{
    
      let mrn = ''
      if (props.mrn) {
        mrn = 'MRN#' + ' ' +  (props.mrn) 
      }
      let title =   (date.age)+' ' + (props.gender)  + ' ' + (props.name) +' '  
      let titleMrn =   (date.age)+' ' + (props.gender)  + ' ' + (props.name) +' '+ (mrn) 

      
      // setTitle(titleMrn)
      // handleTitle(titleMrn)
      // setState({title:titleMrn })
      // let titleMrn =   (date.age)+' ' + (props.gender)  + ' ' + (props.name) +' '+ (mrn) 

      return(
        <React.Fragment>
        <p>
          {title}
        </p>
        <p>
         {mrn}
        </p>
        </React.Fragment>
      )
    }



    // useState({value:"", title: "", name:"", mrn:"", gender:""})
    return(

        // :Patient MR#DOB:
        
        <div className="form-group">
        <Header as='h1' textAlign='center'>Healthcare Brief</Header>

        
         <Form.Field>
                      {/* <label>User Input</label> */}   

                      
        <Header textAlign='left'>TITLE</Header>
        {/* < Input id='title' name='title' placeholder='Please enter a project title...' onChange={props.handleChange}  value={(props.title) + (props.description)} /> */}

 
        <Message style={{background: "transparency",   border: "1px solid transparent"}}>
    {/* <Message.Header>{ (state.value) + ' ' +  (props.title) +' ' + (props.description) + ' ' }</Message.Header> */}
            <Message.Header style={{textAlign:"center"}}>
            {/* {(date.age)+' ' + (props.gender)  + ' ' + (props.name) +' '+ 'MRN#' + ' ' +  (props.mrn) } */}
            <ShowTitle/>
            </Message.Header>
        </Message>

      

        <Header textAlign='left'>PATIENT NAME</Header>
        < Input   name='name' placeholder='Patient Name' onChange={props.handleChange}  value={props.name} />


        <Header textAlign='left'>MRN</Header>
        < Input   name='mrn' placeholder='Patient Mrn' onChange={props.handleChange}  value={props.mrn} />

 


        <Header textAlign='left'>DOB</Header>
 
        <DatePicker
 
        name='dob'
        selected={dt.dob}
        onChange={handleDob }
        // isClearable ={clearDob
        dateFormat="yyyy/MM/dd"
        placeholderText="yyyy/MM/dd"
      >
      
      {/* <input  hidden name="age" onChange={handleAge}  value={props.age} ></input> */}
      </DatePicker>

      <Button onClick={clearDob}> Clear </Button>

        </Form.Field>
  
        <Header textAlign='left'>M/F</Header>
        <Form.Field>
          Selected gender: <b>{state.value}</b>
        </Form.Field>
        <Form.Field>
          <Radio
            label='Female'
            name='radioGroup'
            value='Female'
            checked={state.value === 'Female'}
            onChange={handleGender}
          />
        </Form.Field>
        <Form.Field>
          <Radio
            label='Male'
            name='radioGroup'
            value='Male'
            checked={state.value === 'Male'}
            onChange={handleGender}
          />
        </Form.Field>


        <Header textAlign='left' >what would you like to add?</Header>

        <Form.Field onChange={props.handleChange}  value={props.description} id='description' name='description' label='' control='textarea' 
                            rows='3.2' placeholder='A description of the project and description for your team' />

 




        <br></br><br></br>     <br></br><br></br> <br></br><br></br>


 
 
      </div>
    );
    }
    

